import React from 'react';
import { Table, Row, Col, Button, Dropdown, Pagination } from 'antd';
import { SettingOutlined, DownCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';

import { getParamTable } from '../../../../lib/Helper';
import { Link } from 'react-router-dom';

class Desktop extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    };
  }

  componentDidMount() {
    this.props.fetchTable()
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Table
              columns={[
                {
                  title: 'No',
                  dataIndex: 'rownum',
                  sorter: false,
                  width: '2%',
                }, {
                  title: 'Kategori',
                  dataIndex: 'kategori_nama',
                  sorter: false,
                }, {
                  title: 'Unit',
                  dataIndex: 'unit_nama',
                  sorter: false,
                }, {
                  title: 'Baik',
                  dataIndex: 'jml_baik',
                  sorter: false,
                }, {
                  title: 'Rusak Ringan',
                  dataIndex: 'jml_rusak_ringan',
                  sorter: false,
                }, {
                  title: 'Rusak Berat',
                  dataIndex: 'jml_rusak_berat',
                  sorter: false,
                }, {
                  title: <SettingOutlined />,
                  align: "center",
                  key: 'operation',
                  width: '2%',
                  render: (a, row) => <Dropdown trigger={['click']} menu={{
  items: [...(action.detail === true ? [{
    key: 0,
    label: <Link to={`/sarana-prasarana/asset-tetap/${row.kategori_nama}/${row.unit_nama}/${row.kategori_id}/${row.unit_id}`}><InfoCircleOutlined /> Detail Unit</Link>
  }] : [])]
}}>
                    <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                  </Dropdown>,
                },
              ]}
              rowKey={record => record.id}
              dataSource={table.data}
              pagination={false}
              loading={table.loading}
              size="small"
            />
          </Col>
          <Col xs={24} className="table-pagination">
            <Pagination
              size="small"
              current={table.pagination.current}
              pageSize={table.pagination.pageSize}
              total={table.pagination.total}
              showTotal={() => `Total ${table.pagination.total} items`}
              showSizeChanger
              onChange={(current, pageSize) => {
                const pagination = { current: current, pageSize: pageSize, total: table.pagination.total }
                const params = getParamTable("change", table, null, null, pagination)
                this.props.fetch(params)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
}

export default Desktop;
